module.exports = __webpack_public_path__ + "static/media/user-music.dd8d9114.svg";